import http from '@/lib/http';

export default {
    login(code, state) {
        return http({
            url: `/login?code=${code}&state=${state}`,
            method: 'get'
        });
    },
}